module.exports = __webpack_public_path__ + "static/media/rewriting-the-narrative.b67c7281.png";